const features = [
  {
    icon: "ri-magic-line",
    title: "智能AI生成",
    description: "基于最新深度学习模型，输入文字描述即可快速生成高质量的AI美女图像，无需任何设计基础。",
  },
  {
    icon: "ri-palette-line",
    title: "多样风格选择",
    description: "支持写真、头像、壁纸、虚拟角色等多种风格，古典、现代、梦幻、时尚应有尽有。",
  },
  {
    icon: "ri-speed-up-line",
    title: "秒级出图速度",
    description: "强大的云端算力支持，输入描述后数秒即可生成精美图像，无需漫长等待。",
  },
  {
    icon: "ri-hd-line",
    title: "高清画质输出",
    description: "支持多种分辨率输出，从社交头像到高清壁纸，满足不同场景的画质需求。",
  },
  {
    icon: "ri-shield-check-line",
    title: "安全隐私保护",
    description: "生成的AI美女图像均为原创虚拟形象，不涉及真实人物肖像权问题，安全放心使用。",
  },
  {
    icon: "ri-device-line",
    title: "全平台兼容",
    description: "支持Web端直接使用，无需下载安装，生成的图像可在手机、平板、电脑等设备间自由使用。",
  },
];

export default function Features() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-4">
            为什么选择我们
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            让AI美女创作变得简单
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            我们致力于将最先进的AI图像生成技术，转化为人人都能轻松使用的创作工具。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}